export default __webpack_public_path__ + "static/media/fish.c7188aaa.svg";